import { AutoCompleteService } from 'ionic2-auto-complete';
// import { HttpClient          } from '@angular/common/http';
import { Injectable          } from "@angular/core";
// import { Subject             } from 'rxjs/Subject';
import { UserService         } from './user.service'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switchMap';
import { filter } from 'lodash';


@Injectable()
export class EmployeeAutoCompleteService implements AutoCompleteService {
    formValueAttribute = "numericCode"

    constructor( private $userService: UserService ) {
        this.$userService.dispatchUserFetchAll( 1000, 0, 'employee_nr', 'ASC' );
    }

    getResults( keyword: string) {
        return this.$userService.selectUserSearchAll( keyword ).map( users => filter( users, user => user.active ) );
    }

    getItemLabel(item){
        return item.fullname;
    }
}


// WEBPACK FOOTER //
// ./src/providers/employee-auto-complete.ts